export const localStorageCheck = () => {
	let result = false;
	if (typeof window !== "undefined") {
		if (window.localStorage) {
			result = true;
		}
	}
	return result;
};
